import { BlockType } from "../blockModel/types";

// ---------------------------------------------------------------------------
// Block entries shown in the Palette "Khối" group
// ---------------------------------------------------------------------------

export interface PaletteBlockDef {
	type: BlockType;
	label: string;
	/** Simple text icon / emoji used as visual cue */
	icon: string;
}

// Only types supported by the [[WL-EMAIL]] grammar (Phase 2).
// button / chip / divider are kept in newBlock() for future use but must NOT
// appear here — serialize() throws on them, which would make getContent() throw.
export const PALETTE_BLOCKS: PaletteBlockDef[] = [
	{ type: "paragraph", label: "Đoạn văn", icon: "¶" },
	{ type: "summary", label: "Bảng thông tin", icon: "▤" },
	{ type: "notes", label: "Hộp ghi chú", icon: "🗒" },
];

// ---------------------------------------------------------------------------
// Symbol entries shown in the Palette "Ký hiệu" group
// ---------------------------------------------------------------------------

export const PALETTE_SYMBOLS: string[] = ["✓", "✗", "★", "→", "•", "✉", "☎", "%", "€", "$"];
